import React from 'react';
import {KeyTermsTextInput} from './KeyTermsTextInput';

export const KeyTermsWithInfoTextInput = () => {
  return <KeyTermsTextInput infoText="For multiple key terms use a semicolon." />;
};
